import React from "react";
import BasePopup from "../Popup/index";
import bgMissionCong from "../../../../../assets/images/Mini-Game/bg-mission-cong.png";
import bgMissionCongEn from "../../../../../assets/images/Mini-Game/bg-mission-cong-en.png";
import styled from "styled-components";
import bgCoin from "../../../../../assets/images/Mini-Game/coin-mission.png";
import bgButton from "../../../../../assets/images/Mini-Game/bg-btn-mission.png";
import { useDispatch } from "react-redux";
import {
  setOpenPopupChangeCoinsSuccess,
  setPopupMission,
} from "../../../../../Redux/futures/mini-game/action";
import iconClosePopup from "../../../../../assets/images/Mini-Game/icon-close-popup.svg";
import { Link } from "react-router-dom";
import PATH from "../../../../../config/PATH";
import { ID_TAB_MINI_GAME } from "../../../../../helper/const";
import bgCoinSuper from "../../../../../assets/images/Mini-Game/coin-mission-super.png";
import { useTranslation } from "react-i18next";

export default function PopupMission({
  isOpen = true,
  className,
  data = {},
  getContainer = false,
}) {
  const dispatch = useDispatch();
  const onCancel = () => {
    dispatch(
      setPopupMission({
        isShow: false,
        type: null,
        coin: 0,
        superCoin: 0,
        missionName: null,
      })
    );
  };

  const { t, i18n } = useTranslation()

  const bg_lang_bgMissionCong = i18n.language === 'en' ? bgMissionCongEn : bgMissionCong

  return (
    <BasePopup
      BasePopup
      open={isOpen}
      className={className}
      onCancel={onCancel}
      getContainer={getContainer || false}
    >
      {data?.type === "super_coin" ? (
        <Container className='popup-cong-mini'>
          <img src={bg_lang_bgMissionCong} alt='' className='bg' />
          <img
            src={iconClosePopup}
            alt=''
            className='rule-mini-close button-hover__minigame'
            onClick={onCancel}
          />
          <div className='popup-cong-mini-main'>
            <div className='content-main'>{t("mini_game.pop_up_received_coins.from_mission_super.prefix")}</div>
            <div className='content-coins content-coins-mission' style={{ fontSize: "38px", lineHeight: "40px" }}>
              {data?.coin} Coins <span style={{ fontSize: "14px" }}>{t("mini_game.pop_up_received_coins.from_mission_super.and")}</span> {data?.superCoin} Super Coins
            </div>
            <div className='content-main'>
              {t("mini_game.pop_up_received_coins.from_mission_super.suffix").replace("xxx", data?.dataSelect)}
            </div>
            <div className='img-coins' style={{ margin: "12px auto" }}>
              <img src={bgCoinSuper} alt='' />
            </div>
            <div className='button-action-cong' onClick={onCancel}>
              <img src={bgButton} alt='' />
              <Link
                to={`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`}
                className='button-action-cong-content'
              >
                {t("mini_game.pop_up_received_coins.earn_more_pieces")}
              </Link>
            </div>
          </div>
        </Container>
      ) : data?.type === "normar_coin" ? (
        <Container className='popup-cong-mini'>
          <img src={bg_lang_bgMissionCong} alt='' className='bg' />
          <img
            src={iconClosePopup}
            alt=''
            className='rule-mini-close button-hover__minigame'
            onClick={onCancel}
          />
          <div className='popup-cong-mini-main normal-main'>
            <div className='content-main'>
              {t("mini_game.pop_up_received_coins.from_mission.prefix")}
            </div>
            <div className='content-coins'>{data?.coin} Coins</div>
            <div className='content-main'>
              {t("mini_game.pop_up_received_coins.from_mission.suffix").replace("xxx", data?.dataSelect)}
            </div>
            <div className='img-coins'>
              <img src={bgCoin} alt='' className='bg-coin' />
            </div>
            <div className='button-action-cong flex justify-center' onClick={onCancel}>
              <img src={bgButton} alt='' />
              <Link
                to={`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`}
                className='button-action-cong-content'
              >
                {t("mini_game.pop_up_received_coins.earn_more_pieces")}
              </Link>
            </div>
          </div>
        </Container>
      ) : (
        <Container className='popup-cong-mini'>
          <img src={bg_lang_bgMissionCong} alt='' />
          <img
            src={iconClosePopup}
            alt=''
            className='rule-mini-close button-hover__minigame'
            onClick={onCancel}
          />
          <div className='popup-cong-mini-main normal-main'>
            <div className='content-main'>{t("event_thingyan.pop_up.You have received")}</div>
            <div className='content-coins'>{`${+data?.coin}` > 1 ? data?.coin + " coins" : data?.coin + " coin"}</div>
            <div className='content-main'>from {data?.missionName}</div>
            <div className='img-coins'>
              <img src={bgCoin} alt='' className='bg-coin' />
            </div>
            <div className='button-action-cong flex justify-center' onClick={onCancel}>
              <img src={bgButton} alt='' />
              <Link
                to={`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`}
                className='button-action-cong-content'
              >
                {t("mini_game.earn_more_pieces")}
              </Link>
            </div>
          </div>
        </Container>
      )}
    </BasePopup>
  );
}

const Container = styled.div`
  position: relative;

  @media (min-width: 992px){
    .content-coins-mission{
      line-height: 50px !important;
      font-size: 40px !important;
    }
  }

  .rule-mini-close {
    position: absolute;
    top: 10px;
    right: 0;
    z-index: 4;
  }

  .button-action-cong {
    position: relative;

    .button-action-cong-content {
      position: absolute;
      top: calc(50% - 4px);
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 18px;
      font-weight: 500;
      width: 100%;
    }
    img {
      width: 300px;
      height: 50px;
    }

    @media (max-width: 412px) {
      .button-action-cong-content {
        font-size: 16px;
      }

      img {
        width: 250px;
      }
    }

    @media (max-width: 392px) {
      .button-action-cong-content {
        font-size: 14px;
      }
      img {
        width: 230px;
      }
    }

    @media (max-width: 356px) {
      img {
        width: 230px;
        height: 45px;
      }
    }
  }

  .img-coins {
    text-align: center;
    margin: 12px 0;

    img:first-child {
      margin: 0 auto;
    }

    @media (max-width: 512px) {
      img {
        width: 250px;
        height: auto;
      }

      .bg-coin {
        width: 165px;
      }
    }

    @media (max-width: 452px) {
      img {
        width: 200px;
      }

      .bg-coin {
        width: 150px;
      }
    }

    @media (max-width: 412px) {
      .bg-coin {
        width: 125px;
      }
    }

    @media (max-width: 392px) {
      img {
        width: 150px;
      }
    }

    @media (max-width: 386px) {
      .bg-coin {
        width: 115px;
      }
    }

    @media (max-width: 356px) {
      img {
        width: 125px;
      }

      .bg-coin {
        width: 100px;
      }
    }
  }

  .button-action-cong {
    text-align: center;
  }

  .popup-cong-mini-main {
    position: absolute;
    z-index: 2;
    top: 150px;
    width: 100%;
    width: calc(100% - 64px);
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    /* left: 77px; */

    @media (max-width: 475px) {
      top: 130px;
    }

    @media (max-width: 432px) {
      top: 120px;
    }

    @media (max-width: 412px) {
      top: 110px;
    }

    @media (max-width: 368px) {
      top: 100px;
    }

    @media (max-width: 342px) {
      top: 90px;
    }

    &.normal-main {
      @media (max-width: 492px) {
        top: 130px;
      }

      @media (max-width: 445px) {
        top: 120px;
      }

      @media (max-width: 425px) {
        top: 100px;
      }

      @media (max-width: 368px) {
        top: 90px;
      }
    }
  }

  .content-main {
    color: #64310b;
    font-size: 16px;
    text-align: center;
    font-weight: 500;

    @media (max-width: 432px) {
      font-size: 14px;
    }
  }

  .content-coins {
    color: #954911;
    text-align: center;
    font-size: 48px;
    font-weight: 400;
    line-height: 52px;
    font-family: "Ganache", sans-serif;

    @media (max-width: 475px) {
      font-size: 36px !important;
    }

    @media (max-width: 432px) {
      font-size: 32px !important;
    }

    @media (max-width: 412px) {
      font-size: 28px !important;
    }

    @media (max-width: 356px) {
      font-size: 26px !important;
    }
  }

  @media (min-width: 992px) {
    .button-action-cong {
      &:hover {
        cursor: pointer;
        scale: 1.03;
        transition: 0.3s ease-in-out;
      }
    }
  }
`;
